import styled, { keyframes } from 'styled-components'
import { COLORS } from 'components/reusables/DesignConstants'

/** Pulso en tono secondary: solo expansión hacia afuera (sin contraer el halo en el mismo ciclo). */
export const zoomSyncAlertPulse = keyframes`
  0% {
    box-shadow: 0 0 0 0 rgba(254, 169, 44, 0.45);
  }
  100% {
    box-shadow: 0 0 0 10px rgba(254, 169, 44, 0);
  }
`

export const Title = styled.div`
  color: #213f68;
  font-size: 20px;
  font-weight: 700;
`

export const Description = styled.div`
  margin: 24px 0;
  color: #363636;
  a {
    color: #2684ff;
    display: initial;
    padding-left: 5px;
    transition: 200ms;
    &:hover {
      opacity: 0.7;
    }
  }
`

export const RankmiTableWrapper = styled.div`
  padding-top: 16px;
  .ant-table-wrapper {
    margin-top: -9px;
  }
  .rankmiTable-rowsCount {
    padding-bottom: 10px;
  }
`

/** Fila de acciones en tabla: botones alineados a la derecha de la celda (con o sin alerta Zoom). */
export const WebinarTableActionsRow = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  width: 100%;
`

export const Options = styled.span`
  button {
    background-color: #f0f0f0 !important;
    border-radius: 8px;
    width: 32px;
    padding-left: 13px;
    color: #4c4c4c !important;
    svg {
      transition: 200ms;
    }
    &:hover {
      svg {
        opacity: 0.7;
      }
    }
  }
`

export const EmptyWebinarContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 20px;
`

export const EmptyWebinarIcon = styled.div`
  width: 100px;
  height: 100px;
  background-color: #f0f0f0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;

  .iconWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 60px;
    height: 60px;
    background-color: white;
    border-radius: 50%;
    padding: 10px;
  }
`

export const WebinarName = styled.div`
  font-weight: 700;
  font-size: 14px;
  color: #213f68;
`

export const WebinarCourseName = styled.div`
  font-weight: 400;
  font-size: 12px;
  color: #757575;
`

export const EmptyWebinarText = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #757575;
`

export const PanelistName = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: #363636;
`
export const PanelistEmail = styled.div`
  font-size: 12px;
  font-weight: 400;
  color: #757575;
`

export const StartWebinarButton = styled.div`
  button {
    border-radius: 8px;
    font-size: 14px !important;
    max-width: 134px !important;
    padding: 0 8px !important;
  }
`

export const SoonButton = styled.div`
  button {
    background-color: #e7f3fe;
    border-width: 1px;
    border-color: #b6dbfb;
    border-radius: 8px;
    color: #363636;
    max-width: 134px !important;

    &:hover {
      background-color: #e7f3fe !;
      border-color: #b6dbfb;
      color: inherit !important;
    }
    &:focus {
      background-color: #e7f3fe !important;
      border-color: #b6dbfb !important;
      color: inherit !important;
    }
  }
`

/** Igual que SoonButton (mismas reglas de layout), paleta `COLORS.secondary`. */
export const ZoomSyncAlertButton = styled.div`
  button {
    background-color: rgba(254, 169, 44, 0.12);
    border-width: 1px;
    border-color: rgba(254, 169, 44, 0.5);
    border-radius: 8px;
    color: ${COLORS.secondary};
    max-width: 134px !important;
    animation: ${zoomSyncAlertPulse} 2.2s ease-out infinite;

    @media (prefers-reduced-motion: reduce) {
      animation: none;
    }

    &:hover {
      background-color: rgba(254, 169, 44, 0.18) !important;
      border-color: rgba(254, 169, 44, 0.55) !important;
      color: ${COLORS.secondary} !important;
    }
    &:focus {
      background-color: rgba(254, 169, 44, 0.12) !important;
      border-color: rgba(254, 169, 44, 0.5) !important;
      color: ${COLORS.secondary} !important;
    }
  }
`

export const CopyButton = styled.div`
  button {
    background-color: #e7f3fe;
    border-radius: 8px;
    color: #0085ff;
    font-size: 14px;
    font-weight: 700;

    &:hover {
      background-color: #e7f3fe;
      color: #0085ff;
    }
  }
`

export const PanelistResponsiveTitle = styled.div`
  span {
    color: #757575;
    font-weight: 700;
    font-size: 14px;
  }

  .divider {
    margin: 0;
    margin-top: 4px;
    margin-bottom: 4px;
  }
`

export const JoinURL = styled.div`
  pointer-events: none;
`

export const BadgeResponsiveWebinars = styled.div`
  display: inline-flex;
  align-items: center;
  padding: 4px 8px;
  background-color: #f5f5f5;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  font-size: 14px;
  color: #363636;
  margin-bottom: 12px;
`
